import dayjs from 'dayjs'

import useOrder from './useOrder.main'

//Delivery status:
// 1. scheduled: when the order is created
// 2. pending: when we are assigning a driver
// 3. active: when the driver is on the way to the store

export type TrackingStatus =
  | 'inReview'
  | 'confirmation'
  | 'preparation'
  | 'readyForPickup'
  | 'waitingForDelivery'
  | 'delivery'
  | 'done'
  | 'archived'
  | 'cancelled'

export default function useStatus(): TrackingStatus {
  const {order} = useOrder()

  if (!order) {
    return 'confirmation'
  }

  const {orderStatus, deliveryType, delivery, completedAt, paymentStatus} = order

  if (orderStatus === 'pending' && paymentStatus === 'pending') {
    return 'inReview'
  }

  if (orderStatus === 'pending') {
    return 'confirmation'
  }

  if (orderStatus === 'inReview') {
    return 'inReview'
  }

  if (orderStatus === 'waiting' || orderStatus === 'preparing') {
    if (delivery?.nearStoreAt && deliveryType === 'delivery') {
      return 'waitingForDelivery'
    }
    return 'preparation'
  }

  if (orderStatus === 'delivering' && deliveryType !== 'delivery') {
    return 'readyForPickup'
  }

  if (orderStatus === 'delivering' && deliveryType === 'delivery') {
    return 'delivery'
  }

  if (orderStatus === 'done') {
    if (dayjs(completedAt).isBefore(dayjs().subtract(2, 'hours'))) {
      return 'archived'
    }
    return 'done'
  }

  if (orderStatus === 'cancelled') {
    return 'cancelled'
  }
}
